<section id="intro-ai" class="section-bg-dark">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 pl-5">
        <h2 class="text-white">CONSULTORÍA DE INTELIGENCIA ARTIFICIAL</h2>
      </div>
    </div>
  </div>
</section>

<section id="ai_services">
  <div class="container" style="padding-top: 40px; padding-bottom: 20px;">
    <div class="row">
      <div class="col-sm-12 col-xs-12">
        <p class="font-medium">
          La inteligencia artificial ya no es el futuro: es una ventaja competitiva real y accesible.
          Te ayudamos a entender qué IA necesita tu negocio, cómo integrarla en tus procesos
          y cómo sacarle el máximo partido desde el primer día.
        </p>
      </div>
      <div class="col-sm-12 col-xs-12">
        <p class="font-medium">
          No necesitas ser una empresa tecnológica para beneficiarte de la IA.
          Solo necesitas el acompañamiento adecuado para tomar las decisiones correctas.
        </p>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="container">
      <div class="row p-2">
        <div class="col-xs-12 w-100 text-center p-4">
          <h2>CÓMO TE AYUDAMOS</h2>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      @for (section of sections; track section) {
      <div class="card col-sm-12 col-md-4 text-center p-2 mt-3">
        <div class="card-body">
          <div class="border_box">
            <h5>{{ section.title }}</h5>
            <p>{{ section.description }}</p>
          </div>
        </div>
      </div>
      }
    </div>
  </div>

</section>

<section id="ai-logos" style="padding: 40px 0;">
  <div class="container">
    <div class="row p-2">
      <div class="col-xs-12 w-100 text-center p-4">
        <h2>PLATAFORMAS CON LAS QUE TRABAJAMOS</h2>
      </div>
    </div>

    <div id="aiCarousel" class="carousel slide" data-ride="carousel" data-interval="3000">
      <div class="carousel-inner">
        @for (slide of logos; track $index; let i = $index) {
        <div class="carousel-item" [class.active]="i === 0">
          <div class="row justify-content-center align-items-center">
            @for (logo of slide; track logo) {
            <div class="col-6 col-md-3 text-center p-3">
              <img [src]="logo.src" [alt]="logo.alt" style="max-height: 60px; max-width: 140px; object-fit: contain;">
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</section>
